// store.ts
import { configureStore } from "@reduxjs/toolkit";
import pageReducer from '../features/pageSlice';
import itemsSlice from "../features/itemsSlice";
import boxesSlice from "../features/boxSlice";
import bannersSlice from "../features/bannersSlice";
import settingsSlice from "../features/settingssSlice";
import settingModalSlice from "../features/settingModalSlice";
import videoSlice from "../features/videoSlice";
import cryptoSlice from "../features/cryptoSlice";
import couponsSlice from "../features/couponsSlice";
import rewardSlice from "../features/rewardSlice";
import giftCategoriesSlice from "../features/giftCategoriesSlice";

import { keycloakACLReducer, keycloakAuthReducer, keycloakCryptoReducer, keycloakMerkleTreeReducer, keycloakMerkleWalletModalReducer, keycloakUsersReducer, keycloakWalletReducer} from 'keycloakauthmodule'; // ✅ import from installed module

const store = configureStore({
  reducer: {
    page: pageReducer,
    items: itemsSlice,
    boxes: boxesSlice,
    banners: bannersSlice,
    settings: settingsSlice,
    settingsModal: settingModalSlice,
    videos: videoSlice,
    crypto: cryptoSlice,
    coupons: couponsSlice,
    authSlice: keycloakAuthReducer,
    crypto1: keycloakCryptoReducer,
    walletModal: keycloakMerkleWalletModalReducer,
    wallets: keycloakWalletReducer,
    users: keycloakUsersReducer,
    acl: keycloakACLReducer,
    merkleTree: keycloakMerkleTreeReducer,
    rewards:rewardSlice,
    giftCategories:giftCategoriesSlice,
  },
});


// const store = configureStore({
//   reducer: {
    // authSlice: keycloakAuthReducer,
    // page: pageReducer,
    // privateKeysModal: privateKeysModalSlice,
    // crypto: keycloakCryptoReducer,
    // walletModal: walletModalSlice,
    // wallets: keycloakWalletReducer,
    // users: keycloakUsersReducer,
    // acl: keycloakACLReducer,
    // merkleTree: keycloakMerkleTreeReducer,
//   },
// });

// Define AppDispatch and RootState types
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
